export const getNestedValue = (obj, path) => {
  if (!path || typeof path !== 'string') return undefined;
  if (typeof obj === 'string') return obj;
  return path.split('.').reduce((current, key) => current === null || current === void 0 ? void 0 : current[key], obj);
};